var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as go from '../../../../libs/gojs/release/go';
import { NodeElement } from './base/node-element';
import { DiagramConsts } from '../diagram-consts';
var RectangleElement = /** @class */ (function (_super) {
    __extends(RectangleElement, _super);
    function RectangleElement() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RectangleElement.prototype.compile = function (model, data, svg) {
        model['version'] = 4;
        model['fill'] = data.fill;
        model['stroke'] = data.stroke;
        model['strokeWidth'] = data.strokeWidth;
        model['width'] = data.width;
        model['height'] = data.height;
        model['angle'] = data.angle;
        if (!model['size']) {
            model['size'] = this.sizeService.parse(String(data.width) + ' ' + String(data.height));
        }
        if (this.hasDynamicSetting(data)) {
            model['dynamicSetting'] = data.dynamicSetting;
            model['location'] = go.Point.parse(data.loc);
            model['fixedPositionType'] = data.fixedPositionType;
        }
    };
    RectangleElement.prototype.getPaletteTemplate = function () {
        var $ = go.GraphObject.make;
        return $(go.Node, 'Vertical', { width: 50, height: 90, locationSpot: go.Spot.Center }, $(go.Shape, 'Rectangle', { margin: 10, fill: 'transparent', width: 40, height: 40, stroke: '#999999' }), $(go.TextBlock, { alignment: go.Spot.Center, text: this.l(this.getCategoryKey()), editable: false }));
    };
    RectangleElement.prototype.getDiagramTemplate = function () {
        var _this = this;
        var $ = go.GraphObject.make;
        return $(go.Node, 'Vertical', {
            rotatable: true,
            locationObjectName: 'SHAPE', locationSpot: go.Spot.TopLeft, resizable: true, resizeObjectName: 'SHAPE',
            selectionAdornmentTemplate: $(go.Adornment, 'Spot', $(go.Panel, go.Panel.Auto, $(go.Shape, { fill: null, stroke: 'dodgerblue', strokeWidth: 1 }, new go.Binding('stroke', 'locked', function (locked) { return locked ? '#f65177' : 'dodgerblue'; })), $(go.Placeholder)))
        }, new go.Binding('locationSpot', '', function (data) {
            return _this.getFixedPositionType(data);
        }), new go.Binding('angle').makeTwoWay(), new go.Binding('movable', 'locked', function (locked) { return !locked; }), new go.Binding('resizable', 'locked', function (locked) { return !locked; }), new go.Binding('deletable', 'locked', function (locked) { return !locked; }), new go.Binding('rotatable', 'locked', function (locked) { return !locked; }), new go.Binding('location', 'loc', go.Point.parse).makeTwoWay(go.Point.stringify), new go.Binding('zOrder'), $(go.Shape, 'Rectangle', { name: 'SHAPE', fill: '#ffffff', stroke: '#333', strokeWidth: 1, width: 120, height: 80 }, new go.Binding('fill'), new go.Binding('stroke'), new go.Binding('strokeWidth'), new go.Binding('width').makeTwoWay(), new go.Binding('height').makeTwoWay()));
    };
    RectangleElement.prototype.getCategoryKey = function () {
        return DiagramConsts.elements.rectangleKey;
    };
    return RectangleElement;
}(NodeElement));
export { RectangleElement };
